export default "__VITE_ASSET__42a307d8__"